<fd-dynamic-page
  [autoResponsive]="false"
  size="small"
  class="content-details-container"
>
  <fd-dynamic-page-header>
    <div class="header-container" *fdDynamicPageHeaderTitle>
      <app-icon
        class="title-icon"
        [icon]="resource?.type | resourceGlyph"
        size="lg"
      ></app-icon>
      <h3 fd-title>{{ resource?.displayName }}</h3>
    </div>
    <fd-dynamic-page-global-actions>
      <div class="buttons-container">
        @if (showMidColumnControls) {
          <button
            fd-button
            id="details-close-btn"
            class="close-fcl-button"
            fdType="transparent"
            aria-label="Close"
            (click)="onClose()"
            title="Close"
          >
            <app-icon icon="xmark" size="xl"></app-icon>
          </button>
        }
      </div>
      <div>
        <button
          fd-button
          class="refresh-fcl-button"
          i18n-title="
            XTOL|Tooltip for reload
            button@@organizations.content-details.reloadButtonTooltip"
          [fdCompact]="true"
          [disabled]="loadingResource"
          (click)="onReloadResource()"
          title="Refresh"
          fdType="transparent"
        >
          <app-icon
            icon="rotate-right"
            size="lg"
            [fixedWidth]="true"
          ></app-icon>
        </button>

        @if (showAnalyzeFailure) {
          <button
            fd-button
            class="analyze-failure-fcl-button"
            [fdCompact]="true"
            (click)="onAnalyzeFailure(resource)"
            title="Analyze Failure"
            aria-label="Analyze Failure"
            fdType="transparent"
          >
            <fd-icon glyph="ai" class="ai-assistant-glyph"></fd-icon>
          </button>
        }

        <app-organization-actions
          id="actions-menu"
          [busy]="policiesLoading"
          [resource]="resource"
          [isFclClosed]="false"
          [isFull]="false"
          (delete)="delete.emit($event)"
          (editOrganization)="editOrganization.emit($event)"
          (editWithForm)="editWithForm.emit($event)"
          (reloadResource)="onReloadResource()"
          (reconcileResource)="onReconcileResource.emit($event)"
          (analyzeFailure)="onAnalyzeFailure($event)"
        ></app-organization-actions>
      </div>
    </fd-dynamic-page-global-actions>
  </fd-dynamic-page-header>
  <fd-tab-list
    #tabListComponent
    id="detailsTabList"
    (selectedTabChange)="onTabChange($event)"
  >
    <fd-tab #detailsTab id="detailsDetailsTab">
      <ng-template fd-tab-title-template>
        <span fd-tab-tag>Details</span>
      </ng-template>
      <div class="atom-fcl-content">
        <div class="details-container">
          <app-details
            #detailsComponent
            [loading]="loadingResource"
            (onEditResource)="onEditResource.emit($event)"
            (reloadResource)="reloadResource.emit($event)"
          ></app-details>
        </div>
      </div>
    </fd-tab>

    <fd-tab #relationsTab id="relationsTab">
      <ng-template fd-tab-title-template>
        <span fd-tab-tag>References</span>
      </ng-template>
      <div class="atom-fcl-content">
        <div class="relations-container">
          <div #relationsComponent></div>
        </div>
      </div>
    </fd-tab>

    <fd-tab #eventsTab id="eventsTab">
      <ng-template fd-tab-title-template>
        <span fd-tab-tag>Events</span>
      </ng-template>
      <div class="atom-fcl-content">
        <div class="events-container">
          <div #eventsComponent></div>
        </div>
      </div>
    </fd-tab>

    @if (Utils.isManagedService(resource)) {
      <fd-tab #resourcesTab id="resourcesTab">
        <ng-template fd-tab-title-template>
          <span fd-tab-tag>RTD Type Resources</span>
        </ng-template>
        <div class="atom-fcl-content">
          <app-rtd-type-resources-table
            #rtdResourcesComponent
            class="rtd-table"
            [loading]="loadingRTDResources"
            [errorDetails]="rtdErrorDetails"
            [rtdResources]="rtdResources"
            [resource]="resource"
            (permissionsAdded)="onUpdateRTDResource.emit($event)"
            [hasPrivilegesPermissions]="hasPrivilegesPermissions"
            [rtdResourcesStateMessage]="rtdResourcesStateMessage"
          ></app-rtd-type-resources-table>
        </div>
      </fd-tab>
    }

    @if (isAutomation()) {
      <fd-tab #automationTab id="automationTab">
        <ng-template fd-tab-title-template>
          <span fd-tab-tag>Automation</span>
        </ng-template>
        <div class="atom-fcl-content">
          <div class="automation-container">
            <div #automationComponent></div>
          </div>
        </div>
      </fd-tab>
    }
  </fd-tab-list>
</fd-dynamic-page>
